import React from 'react';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';
import { AvPageGuard } from './AvPageGuard';

export const SensitivePageGuard = ({ children }) => (
  <AvPageGuard
    title="Global Customer Information"
    messageElement={
      <Box sx={{ ...flex.colItemsStart, gap: 2 }}>
        <div>This page contains cross-customer data.</div>
        <div>Are you sure you want to proceed?</div>
      </Box>
    }>
    {children}
  </AvPageGuard>
);
